import { createI18n as e } from "../node_modules/.pnpm/vue-i18n@11.1.12_vue@3.5.18/node_modules/vue-i18n/dist/vue-i18n.js";
const t = {
  "en-US": {
    批量配置到同类产品: "批量配置到同类产品",
    批量配置到全部产品: "批量配置到全部产品",
    是: "Yes",
    否: "No",
    确定: "Confirm",
    取消: "Cancel",
    请输入: "Please enter",
    请选择: "Please select",
    配置商品参数: "configParam",
    商品名称: "productName",
    "请选择水龙头型号！": "Pls select faucet model!",
    商品数量合需要和合计一致: "Goods QTY need to match the overall total",
    "请填写完整{attributeName}": "Pls complete {attributeName}",
    "{attributeName}必填": "{attributeName} Required",
    定制板件: "Custom panels",
    加载中: "Loading...",
    "注意：橱柜、衣柜、卫浴有纹路板件纹路方向平行于长度方向": "Note: kitchen, wardrobes and bathrooms have textured panels with textured direction in parallel to the length direction",
    窗幔: "Window curtain",
    "请填写{label}": "Pls complete {label}",
    "左转包尺寸-宽": "Left Turn cover size-Width",
    "请输入左转包尺寸-宽": "Pls enter left size-width",
    "右转包尺寸-宽": "Right size-width",
    "请输入右转包尺寸-宽": "Pls enter the right size-width",
    "成品尺寸-高": "size-height",
    "请输入成品尺寸-高": "Pls enter finished size-height",
    "请输入正面尺寸-宽": "Pls enter front size-width",
    "正面尺寸-宽": "Front size-width",
    "注：加急需收取加急费35元": "Note: An urgent fee of 35 yuan will be charged for urgent needs",
    贴合方式: "Fitting method",
    请选择主布A面料: "Pls select the main fabric A",
    请选择配布B面料: "Pls select Matching fabric B",
    附件: "Attachments",
    配布B面料: "Matching fabric B",
    主布A面料: "Main Fabric A",
    请选择开合方式: "Pls select opening and closing method",
    房间名: "Room Name",
    操作成功: "Operation Successful",
    配送方式: "Delivery method",
    请选择配送方式: "Pls select delivery method",
    是否加急: "Whether urgent",
    是否特殊定制: "Whether customized",
    导轨: "Slide",
    导轨尺寸: "Slide size",
    请输入尺寸: "Pls enter the size",
    安装方式: "Installation method",
    请选择安装方式: "Pls select installation method",
    帘身: "Curtain",
    下单说明: "Order instructions",
    BAB拼接: "BAB splicing",
    ABC拼接: "ABC splicing",
    平幔遮轨: "Flat valance track cover",
    拼接方式: "Splicing method",
    请选择拼接方式: "Pls select splicing method",
    加工方式: "Processing method",
    打褶倍数: "Pleating ratio",
    请选择打褶倍数: "Pls select pleating multiple",
    请选择加工方式: "Pls select processing method",
    配布拼褶: "Fabric patchwork",
    请选择配布拼褶: "Pls select fabric patchwork",
    "主布为窗帘大面积色，单价系数为1.2，下单请参照“两色三拼接图示”提供画图信息并上传": "The main fabric is the curtain's large area color, unit price coefficient is 1.2. Refer to the 'Two-Color Three-Piece Diagram,' provide drawing info, and upload.",
    "主布为窗帘大面积色，单价系数为1.2，下单请参照“三色拼接图示”提供画图信息并上传": "The main fabric is the curtain's large area color, with a unit price coefficient of 1.2. Refer to the 'Three-Color Stitching Diagram,' provide drawing info, and upload.",
    "默认6公分普通平幔，车缝魔术贴，默认反贴，无法选择帘幔高度": "Default 6 cm standard flat valance, sewn with Velcro, reverse Velcro by default, curtain valance height cannot be selected.",
    开合方式: "Opening and closing mode",
    主布A型号: "Main fabric A",
    请选择主布A型号: "Pls select the main fabric A",
    配布B型号: "Matching fabric B",
    请选择配布B型号: "Pls select Distribution B",
    配布C型号: "Matching fabric C",
    请选择配布C型号: "Pls select fabric C",
    成品高: "Height",
    是否定型: "Whether it is shaped",
    是否对花: "Pattern alignment",
    请选择抱枕型号: "Pls select pillow model",
    抱枕数量: "Pillows QTY",
    抱枕型号: "Pillow model",
    计算: "Calculate",
    成品宽: "Width",
    是否顶部飘菲遮轨: "Whether the top floating rail is covered",
    收起: "Retract",
    尺寸定制: "Size customization",
    余料做抱枕: "Making pillows with leftover materials",
    展开更多: "Expand more",
    "商品清单（数量减到0即为删除）": "Product list (qty reduced to 0 means to delete)",
    "请输入名称、型号等": "Pls enter name, model, etc",
    "定宽/定高": "Fixed width/height",
    "成品宽（毫米）": "Width (mm)",
    "成品高（毫米）": "Height (mm)",
    "拉绳长度（毫米）": "Drawstring length (mm)",
    "请选择定宽/定高": "Pls select fixed width/height",
    异形挖孔数: "Special-shaped holes qty",
    请输入整数: "Pls enter an integer",
    异型斜角帘: "Special-shaped bevel curtain",
    请选择异型斜角帘: "Pls select special-shaped bevel curtain",
    是否平幔遮轨: "Whether flat valance track cover",
    是否拼搭接高: "Whether to assemble the overlap height",
    更多尺寸: "More sizes",
    左帘宽: "Left curtain width",
    右帘宽: "Right curtain width",
    中帘宽: "Middle curtain width",
    帘身花边: "Curtain lace",
    平拉帘: "Flat curtain",
    "各帘宽之和不得大于成品宽！": "Curtains whole widths shall not be greater than product width!",
    请选择花边类型: "Pls select lace type",
    花边类型: "Lace Type",
    花边长度: "Lace length",
    里衬: "Lining",
    请选择里衬型号: "Pls select lining model",
    里衬型号: "Lining model",
    定制: "Customization",
    手动拉绳安装位置: "Manual pull cord installation position",
    "纱帘/里衬": "Gauze curtain/lining",
    "请输入成品尺寸-宽": "Pls enter finished size-wide",
    请选择手动拉绳安装位置: "Pls select the manual pull cord installation location",
    请选择电机安装位置: "Pls select motor installation location",
    电机安装位置: "Motor Installation Position",
    "成品尺寸-宽": "Size-Width",
    备注: "Remarks"
  },
  "zh-CN": {
    批量配置到同类产品: "批量配置到同类产品",
    批量配置到全部产品: "批量配置到全部产品",
    是: "是",
    否: "否",
    确定: "确定",
    取消: "取消",
    请输入: "请输入",
    请选择: "请选择",
    配置商品参数: "配置商品参数",
    商品名称: "商品名称",
    "请选择水龙头型号！": "请选择水龙头型号！",
    商品数量合需要和合计一致: "商品数量合需要和合计一致",
    "请填写完整{attributeName}": "请填写完整{attributeName}",
    "{attributeName}必填": "{attributeName}必填",
    定制板件: "定制板件",
    加载中: "加载中",
    "注意：橱柜、衣柜、卫浴有纹路板件纹路方向平行于长度方向": "注意：橱柜、衣柜、卫浴有纹路板件纹路方向平行于长度方向",
    窗幔: "窗幔",
    "请填写{label}": "请填写{label}",
    "左转包尺寸-宽": "左转包尺寸-宽",
    "请输入左转包尺寸-宽": "请输入左转包尺寸-宽",
    "右转包尺寸-宽": "右转包尺寸-宽",
    "请输入右转包尺寸-宽": "请输入右转包尺寸-宽",
    "成品尺寸-高": "成品尺寸-高",
    "请输入成品尺寸-高": "请输入成品尺寸-高",
    "请输入正面尺寸-宽": "请输入正面尺寸-宽",
    "正面尺寸-宽": "正面尺寸-宽",
    "注：加急需收取加急费35元": "注：加急需收取加急费35元",
    贴合方式: "贴合方式",
    请选择开合方式: "请选择开合方式",
    请选择主布A面料: "请选择主布A面料",
    请选择配布B面料: "请选择配布B面料",
    附件: "附件",
    配布B面料: "配布B面料",
    主布A面料: "主布A面料",
    房间名: "房间名",
    操作成功: "操作成功",
    配送方式: "配送方式",
    请选择配送方式: "请选择配送方式",
    是否加急: "是否加急",
    是否特殊定制: "是否特殊定制",
    请上传附件: "请上传附件",
    导轨: "导轨",
    导轨尺寸: "导轨尺寸",
    请输入尺寸: "请输入尺寸",
    安装方式: "安装方式",
    请选择安装方式: "请选择安装方式",
    "操作失败，请检查输入项": "操作失败，请检查输入项",
    帘身: "帘身",
    下单说明: "下单说明",
    BAB拼接: "BAB拼接",
    ABC拼接: "ABC拼接",
    平幔遮轨: "平幔遮轨",
    拼接方式: "拼接方式",
    请选择拼接方式: "请选择拼接方式",
    加工方式: "加工方式",
    打褶倍数: "打褶倍数",
    请选择打褶倍数: "请选择打褶倍数",
    请选择加工方式: "请选择加工方式",
    配布拼褶: "配布拼褶",
    请选择配布拼褶: "请选择配布拼褶",
    "主布为窗帘大面积色，单价系数为1.2，下单请参照“两色三拼接图示”提供画图信息并上传": "主布为窗帘大面积色，单价系数为1.2，下单请参照“两色三拼接图示”提供画图信息并上传",
    "主布为窗帘大面积色，单价系数为1.2，下单请参照“三色拼接图示”提供画图信息并上传": "主布为窗帘大面积色，单价系数为1.2，下单请参照“三色拼接图示”提供画图信息并上传",
    "默认6公分普通平幔，车缝魔术贴，默认反贴，无法选择帘幔高度": "默认6公分普通平幔，车缝魔术贴，默认反贴，无法选择帘幔高度",
    开合方式: "开合方式",
    主布A型号: "主布A型号",
    请选择主布A型号: "请选择主布A型号",
    配布B型号: "配布B型号",
    请选择配布B型号: "请选择配布B型号",
    配布C型号: "配布C型号",
    请选择配布C型号: "请选择配布C型号",
    成品高: "成品高",
    是否定型: "是否定型",
    是否对花: "是否对花",
    请选择抱枕型号: "请选择抱枕型号",
    抱枕数量: "抱枕数量",
    抱枕型号: "抱枕型号",
    计算: "计算",
    成品宽: "成品宽",
    是否顶部飘菲遮轨: "是否顶部飘菲遮轨",
    收起: "收起",
    尺寸定制: "尺寸定制",
    余料做抱枕: "余料做抱枕",
    展开更多: "展开更多",
    "商品清单（数量减到0即为删除）": "商品清单（数量减到0即为删除）",
    "请输入名称、型号等": "请输入名称、型号等",
    "定宽/定高": "定宽/定高",
    "成品宽（毫米）": "成品宽（毫米）",
    "成品高（毫米）": "成品高（毫米）",
    "拉绳长度（毫米）": "拉绳长度（毫米）",
    "请选择定宽/定高": "请选择定宽/定高",
    异形挖孔数: "异形挖孔数",
    请输入整数: "请输入整数",
    异型斜角帘: "异型斜角帘",
    请选择异型斜角帘: "请选择异型斜角帘",
    是否平幔遮轨: "是否平幔遮轨",
    是否拼搭接高: "是否拼搭接高",
    更多尺寸: "更多尺寸",
    左帘宽: "左帘宽",
    右帘宽: "右帘宽",
    中帘宽: "中帘宽",
    帘身花边: "帘身花边",
    平拉帘: "平拉帘",
    "各帘宽之和不得大于成品宽！": "各帘宽之和不得大于成品宽！",
    请选择花边类型: "请选择花边类型",
    花边类型: "花边类型",
    花边长度: "花边长度",
    里衬: "里衬",
    请选择里衬型号: "请选择里衬型号",
    里衬型号: "里衬型号",
    定制: "定制",
    手动拉绳安装位置: "手动拉绳安装位置",
    "纱帘/里衬": "纱帘/里衬",
    "请输入成品尺寸-宽": "请输入成品尺寸-宽",
    请选择手动拉绳安装位置: "请选择手动拉绳安装位置",
    请选择电机安装位置: "请选择电机安装位置",
    电机安装位置: "电机安装位置",
    "成品尺寸-宽": "成品尺寸-宽",
    备注: "备注"
  }
}, i = e({
  locale: "zh-CN",
  // 默认语言
  legacy: !1,
  // 使用 Composition API 模式
  messages: t
});
function l() {
  return { i18n: i };
}
export {
  l as useLanguage
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/utils/useLanguage.js
// module id = 110
// module chunks = 67